import { useState } from "react";

export default function ContactUs({ onClose }) {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    zipcode: "",
    message: "",
  });
  const [status, setStatus] = useState("");
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required.";
    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required.";
    } else if (
      !/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(formData.phone)
    ) {
      newErrors.phone = "Please enter a valid phone number.";
    }
    if (!formData.email.trim()) {
      newErrors.email = "Email is required.";
    }
    // Zip code validation (optional but if provided, check format)
    if (formData.zipcode.trim() && !/^\d{5}(-\d{4})?$/.test(formData.zipcode)) {
      newErrors.zipcode = "Please enter a valid zip code.";
    }
    if (!formData.message.trim())
      newErrors.message = "Message is required so that I can best assist you.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("");
    if (!validate()) return;

    try {
      // Create FormData object with all form fields
      const submitFormData = new FormData(e.target);

      const response = await fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(submitFormData).toString(),
      });

      if (response.ok) {
        setStatus("success");
        setFormData({
          name: "",
          phone: "",
          email: "",
          zipcode: "",
          message: "",
        });
      } else {
        setStatus("error");
      }
    } catch {
      setStatus("error");
    }
  };

  return (
    // This is the new full-screen backdrop for the modal
    <div className="modal-backdrop">
      {/* This is the modal container */}
      <div className="contact-card">
        {/* A close button that uses the onClose prop */}
        <button className="modal-close-btn" onClick={onClose}>
          &times;
        </button>

        {status === "success" && (
          <div className="popup-success">
            <h2 style={{ textAlign: "center", marginBottom: "1rem" }}>
              Thank You!
            </h2>
            <p style={{ textAlign: "center", marginBottom: "2rem" }}>
              Your message has been sent.
            </p>
            <h3
              style={{
                textAlign: "center",
                fontSize: "1.5rem",
                marginBottom: "2rem",
              }}
            >
              Now schedule your meeting:
            </h3>

            <div
              style={{
                display: "flex",
                gap: "1rem",
                justifyContent: "center",
                alignItems: "center",
                flexWrap: "wrap",
              }}
            >
              <a
                className="primary-btn"
                href="https://calendly.com/ownyourmoneync/getting-started"
                target="_blank"
                rel="noopener noreferrer"
                style={{ fontSize: "1.2rem", padding: "1rem 2.5rem" }}
              >
                Schedule on Calendly
              </a>

              <button
                className="return-btn"
                onClick={onClose}
                style={{ fontSize: "1.2rem", padding: "1rem 2.5rem" }}
              >
                Return <span style={{ fontSize: "1.2em" }}>&#8592;</span>
              </button>
            </div>
          </div>
        )}
        {status === "error" && (
          <div className="popup-error">
            <p>
              Sorry, there was an error sending your message. Please try again.
            </p>
            {/* The return button now also uses the onClose prop */}
            <button className="return-btn" onClick={onClose}>
              Return <span style={{ fontSize: "1.2em" }}>&#8592;</span>
            </button>
          </div>
        )}
        {status === "" && (
          <form
            name="contact"
            method="POST"
            data-netlify="true"
            data-netlify-honeypot="bot-field"
            onSubmit={handleSubmit}
          >
            <input type="hidden" name="form-name" value="contact" />
            <div style={{ display: "none" }}>
              <label>
                Don't fill this out if you're human: <input name="bot-field" />
              </label>
            </div>
            <div className="form-group">
              <label htmlFor="name">Full Name: *</label>
              <input
                type="text"
                id="name"
                name="name"
                placeholder="Type name here..."
                value={formData.name}
                onChange={handleChange}
                required
              />
              {errors.name && (
                <span style={{ color: "red" }}>{errors.name}</span>
              )}
            </div>

            <div className="form-group">
              <label htmlFor="phone">Phone Number: *</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                placeholder="Type phone number here..."
                value={formData.phone}
                onChange={handleChange}
                required
              />
              {errors.phone && (
                <span style={{ color: "red" }}>{errors.phone}</span>
              )}
            </div>

            <div className="form-group">
              <label htmlFor="email">Email: *</label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Type email here..."
                value={formData.email}
                onChange={handleChange}
                required
              />
              {errors.email && (
                <span style={{ color: "red" }}>{errors.email}</span>
              )}
            </div>

            <div className="form-group">
              <label htmlFor="zipcode">Zip Code:</label>
              <input
                type="text"
                id="zipcode"
                name="zipcode"
                placeholder="Enter zip code..."
                value={formData.zipcode}
                onChange={handleChange}
              />
              {errors.zipcode && (
                <span style={{ color: "red" }}>{errors.zipcode}</span>
              )}
            </div>

            <div className="form-group">
              <label htmlFor="message">
                Please provide some background on why you are scheduling this
                consultation. All information is helpful- thank you! *
              </label>
              <textarea
                id="message"
                name="message"
                placeholder="Enter your answer..."
                value={formData.message}
                onChange={handleChange}
                required
              />
              {errors.message && (
                <span style={{ color: "red" }}>{errors.message}</span>
              )}
            </div>

            <button type="submit" className="submit-btn">
              <strong>Start Your Journey Today!</strong>
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
